import { DokumenteExplorerFolder } from './dossier.models';

/** Titles from the top level down to guid, or null when it is not in the tree. */
export function folderPath(folders: DokumenteExplorerFolder[], guid: string): string[] | null {
  for (const folder of folders) {
    if (folder.guid === guid) {
      return [folder.titel];
    }

    const childPath = folderPath(folder.children, guid);

    if (childPath) {
      return [folder.titel, ...childPath];
    }
  }

  return null;
}
